<template>
  <div class="all" v-loading="loading" element-loading-text="加载中,请稍后...">
    <div class="main">
      <div class="head-main">
        <p class="tip-1st">生涯规划咨询师培训课程</p>
        <el-button size="small" @click="Continuelearning()">继续学习</el-button>
      </div>
      <div class="foot-main">
        <div v-show="playersShow" id="players"></div>
      </div>

      <div style="width:100%;height:500px;background-color:#02203A">
        <el-container>
          <el-header
            style="height:40px;text-align: left; font-size: 18px;color:#ffffff;padding-top:8px;border-bottom:1px solid rgb(94,114,131)"
          >
            <span>目录</span>
          </el-header>
        </el-container>
        <div class="menu">
          <div v-for="(item, index) in homedirectory" :key="index">
            <div class="homedirectory">
              <span style="margin-right:10px">{{ item.title }}</span
              ><span>{{ item.intro }}</span>
            </div>
            <el-timeline>
              <el-timeline-item
                v-for="(e, i) in item.infos"
                :key="i"
                :class="
                  item.id == uid && e.cou_id == id
                    ? 'subdirectory-right'
                    : 'subdirectory'
                "
                :color="
                  e.is_study == 0
                    ? '#FFFFFF'
                    : e.is_study == 1
                    ? '#112CEF'
                    : e.is_study == 2
                    ? 'saddlebrown'
                    : '#8F939C'
                "
              >
                <div
                  @click="study(item.id, e.cou_id, e.id)"
                  :title="e.article.art_title"
                >
                  <span style="margin-left:20px;">{{
                    e.article.art_title
                  }}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="支付"
      :visible.sync="dialogVisible"
      width="550px"
      v-loading="loading"
      :close-on-click-modal="false"
      center
      class="payStyle"
      :show-close="false"
    >
      <div style="margin-bottom:10px">
        <span>付费内容:</span>
        培训教材、评测练习、正式评测、评测审核、证书制作、证书颁发。
      </div>
      <div v-if="payRadio == '1'">
        <span>输入兑换码: </span>
        <el-input
          placeholder="请输入兑换码"
          class="redeem"
          v-model="redeemData"
        ></el-input>
        <p class="warnRed">*请注意区分大小写</p>
      </div>
      <div style="margin-bottom:10px" v-else>
        <span>支付金额: </span>{{ this.$price }}
      </div>
      <div>
        <span>支付方式:</span>
        <!-- <el-radio v-model="payRadio" label="1" class="radio" border>微信支付</el-radio> -->
        <el-radio v-model="payRadio" label="1" class="radio" border
          >兑换码</el-radio
        >
      </div>
      <!-- <el-button type="danger" @click="toPay" v-if="payRadio == '1'" class="button"
        >立即支付</el-button
      > -->
      <el-button type="danger" @click="toRedeem" class="button"
        >立即兑换</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import * as qiniu from 'qiniu-js'
import QPlayer from '../../../index/assets/js/qiniu-web-player-1.2.3'
export default {
  name: 'videoplays',
  data() {
    return {
      playersShow: true,
      players: null,
      play: {},
      id: '',
      dialogVisible: false,
      payRadio: '1',
      redeemData: '',
      loading: false,
      cookieId: '',
      tableData: null,
      homedirectory: [],
      idlist: [],
      i: '',
      nextIndex: '',
      nextZtindex: '',
      video: {},
      data: {},
      seek: null,
      photo1st: require('../../../admin/assets/images/up.png'),
      photo2nd: require('../../../admin/assets/images/updown.png'),
      photo3rd: require('../../../admin/assets/images/down.png'),
      photo4th: require('../../../admin/assets/images/ellipse.png'),
      fullscreenLoading: false,
      cid: '',
      order_number: {},
      redeem_number: {},
    }
  },
  watch: {
    $route() {
      this.videopost()
      window.location.reload()
    },
  },
  methods: {
    study(uid, id) {
      this.$router.push({ name: 'Videoplays', params: { uid, id } })
    },
    Continuelearning() {
      let _this = this
      this.id = this.$route.params.id //二级路由课程传值
      this.uid = this.$route.params.uid //一级路由章节传值

      _this.homedirectory.forEach((e, i) => {
        if (_this.uid == e.id) {
          _this.nextZtindex = i
        }
      }) //遍历当前章节列表  如果当前通过传值获取的一级路由ID为遍历列表中章节ID  则该章节下标为_this.nextZtindex

      if (_this.homedirectory.length - 1 < _this.nextZtindex) {
        return
      }
      //在章节列表的末尾停止点击事件并返回

      _this.homedirectory[_this.nextZtindex].infos.forEach((e, i) => {
        if (_this.id == e.cou_id) {
          _this.nextIndex = i
        }
      })
      //遍历当前课程列表 如果当前通过传值获取的二级路由ID为遍历列表中章节ID 则该课程下标为_this.nextIndex

      if (
        _this.homedirectory[_this.nextZtindex].infos.length - 1 <=
          _this.nextIndex &&
        _this.homedirectory.length - 1 > _this.nextZtindex
      ) {
        _this.nextZtindex++
        let uid = _this.homedirectory[_this.nextZtindex].id
        let id = _this.homedirectory[_this.nextZtindex].infos[0].cou_id
        _this.$router.push({
          name: 'Videoplays',
          params: { uid: uid, id: id },
        })
        return
      } else if (
        _this.homedirectory[_this.nextZtindex].infos.length - 1 ==
          _this.nextIndex &&
        _this.homedirectory.length - 1 == _this.nextZtindex
      ) {
        return
      }

      _this.nextIndex++
      //点击按钮章节列表下标递增
      let id =
        _this.homedirectory[_this.nextZtindex].infos[_this.nextIndex].cou_id
      //将递增后的下标赋值给id
      _this.$router.push({
        name: 'Videoplays',
        params: { uid: _this.uid, id: id },
      })
      //如果在当前章节列表中的最后一个课程则直接递增 并完成章节列表的路由递增跳转直至最后一个章节停止
    },
    player() {
      var seektime = 0
      let _this = this
      let player
      document.getElementById('players').innerHTML = ''
      let u = navigator.userAgent
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isIOS) {
        player = new QPlayer({
          url: process.env.VUE_APP_FILEURL + this.play.section,
          poster: process.env.VUE_APP_FILEURL + this.play.cover,
          container: document.getElementById('players'),
          loggerLevel: 3,
        })
        this.players = player
      } else {
        player = new QPlayer({
          url: process.env.VUE_APP_FILEURL + this.play.section,
          poster: process.env.VUE_APP_FILEURL + this.play.cover,
          container: document.getElementById('players'),
          hls: { isG711: true },
          g711Wasm: 'https://resource.netclass.cn/aac_wasm.wasm',
          loggerLevel: 3,
        })
        this.players = player
      }

      this.seek = setInterval(() => {
        if (seektime >= _this.play.length_time) {
          _this.liveShowFalse()
        }
        seektime = seektime + 1
      }, 1000)

      let time = 1
      this.players.on('timeupdate', function(d, z) {
        // if (_this.data.is_study != 1) {
        //   if (d > seektime + 20) {
        //     _this.seekFunc(seektime)
        //   }
        // }

        if (d > z * 0.9 && time == 1) {
          time = 2
          _this.artClickFinish()
        }

        var list = []
        if (!localStorage.getItem('currentime')) {
          list.push({
            id: _this.id,
            uid: _this.uid,
            time: player.currentTime,
          })
          localStorage.setItem('currentime', JSON.stringify(list))
        } else {
          let arr = JSON.parse(localStorage.getItem('currentime'))
          let index = arr.findIndex(
            item => item.id === _this.id && item.uid === _this.uid
          )
          if (index != -1) {
            arr[index].time = player.currentTime
          } else {
            arr.push({
              id: _this.id,
              uid: _this.uid,
              time: player.currentTime,
            })
          }
          localStorage.setItem('currentime', JSON.stringify(arr))
        }
      })

      this.players.on('ready', function() {
        if (localStorage.getItem('currentime')) {
          let list = JSON.parse(localStorage.getItem('currentime'))
          let index = list.findIndex(
            item => item.id === _this.id && item.uid === _this.uid
          )
          if (index != -1) {
            _this.seekFunc(list[index].time)
          }
        } else {
          return
        }
      })
      this.players.on('pause', function() {
        this.seektime = player.currentTime
      })
    },

    seekFunc(d) {
      this.players.seek(d)
    },
    liveShowFalse() {
      //清除定时器
      clearInterval(this.seek)
      this.seek = null
    },
    videopost() {
      let _this = this
      _this.loading = true
      if (this.$store.state.wps_user.mobile) {
        _this.$http
          .post(process.env.VUE_APP_URL + 'article/getArtinfo/' + this.id, {
            clist_id: this.cid,
          })
          .then(data => {
            if (data.data.code == 201) {
              this.dialogVisible = true
              return
            } else if (data.data.code == 403) {
              this.$message.error(data.data.msg)
            } else {
              _this.loading = false
              this.play = data.data.data.resource
              this.data = data.data.data
              this.dialogVisible = false
              if (this.play) {
                _this.player()
                return
              }
            }
          })
          .catch(err => {
            _this.$message.error('网络错误，请重试')
            console.log(err)
          })
      } else {
        this.$message.warning('您还未登录，请先登录！')
      }
    },
    artClickFinish() {
      let _this = this
      _this.$http
        .post(process.env.VUE_APP_URL + 'article/artClickFinish', {
          clist_id: this.cid,
          id: this.data.id,
        })
        .then(data => {})
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    toPay() {
      //去支付
      this.toExam()
    },
    init() {
      let _this = this
      this.fullscreenLoading = true
      setTimeout(() => {
        this.fullscreenLoading = false
      }, 800)
      _this.$http
        .post(process.env.VUE_APP_URL + 'article/courseBig', {
          id: this.cid,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data
            _this.homedirectory = data.data.data.list
          } else {
            _this.$message.error(data.data.msg)
            return
          }
        })
        .catch(function(error) {
          _this.$message.error('网络错误，请刷新界面重试')
          return
        })
    },
    toExam() {
      let _this = this
      let subsystem_url = window.location.href
      _this.$http
        .post(process.env.VUE_APP_URL + 'order', {
          clist_id: this.cid,
          subsystem_url: subsystem_url,
        })
        .then(data => {
          if (data.data.code == 200) {
            //未付款
            _this.order_number = data.data.data
            window.location.href =
              'http://pay.netban.cn/pay/' + this.order_number //跳转至支付页面
          } else if (data.data.code == 201) {
            //已付款
            _this.$message.error(data.data.msg)
          }
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    toRedeem() {
      //兑换码
      let _this = this
      _this.loading = true
      let subsystem_url = window.location.href
      _this.$http
        .post(process.env.VUE_APP_URL + 'exchange', {
          clist_id: this.cid,
          numbers: this.redeemData,
          subsystem_url: subsystem_url,
        })
        .then(data => {
          _this.loading = false
          if (data.data.code == 403 || data.data.code == 500) {
            _this.$message.error(data.data.msg)
            return
          }
          _this.redeem_number = data.data.data
          if (this.redeem_number) {
            window.location.href =
              'http://pay.netban.cn/pay/' + this.redeem_number //跳转至支付页面
          }
          _this.dialogVisible = false
          _this.$message.success(data.data.msg)
          this.videopost()
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          _this.loading = false
          console.log(err)
        })
    },
  },
  created() {},
  mounted() {
    this.id = this.$route.params.id
    this.uid = this.$route.params.uid
    this.cid = this.$route.params.cid
    this.videopost()
    this.init()
  },
}
</script>

<style lang="less" scoped>
.all {
  min-height: 95vh;
  width: 100%;
  background-color: #163d5e;
  color: #b1aaaa;
}
.main {
  width: 100%;
  min-height: 80vh;
}
.head-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
}
.tip-1st {
  color: #ffffff;
  font-size: 25px;
  letter-spacing: 3px;
}
.tip-2nd {
  color: rgb(250, 254, 254);
  border-radius: 40px;
  border: 2px solid rgb(58, 96, 140);
  padding: 5px 30px 5px 30px;
  font-size: 15px;
  letter-spacing: 1px;
  background-color: rgb(14, 56, 140);
  cursor: pointer;
}
.foot-main {
  display: flex;
}
h1 {
  margin-top: 20px;
  font-size: 50px;
}
.redeem {
  padding: 10px 10px 0 0;
}
.button {
  margin-top: 10px;
}
.radio {
  margin-left: 10px;
}
.menu {
  height: 460px;
  border-right: inherit;
  overflow: scroll;
}
.homedirectory {
  font-size: 16px;
  padding: 15px;
  color: #ffffff;
}
.homedirectory span {
  margin-right: 10px;
}
.subdirectory {
  height: 35px;
  color: #f5f6fc;
  cursor: pointer;
  line-height: 65px;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #f5f6fc;
  }
}
.subdirectory-right {
  height: 35px;
  color: #f5f6fc;
  cursor: pointer;
  background-color: rgb(29, 55, 78);
  line-height: 65px;
  div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #f5f6fc;
  }
}

//  .subdirectory-false{
//   font-size:14px;
//   color: #F5F6FC;
//   cursor:pointer;
// }
.subdirectory:hover {
  background-color: rgb(29, 55, 78);
  width: auto;
}
.subdirectory-right:hover {
  background-color: rgb(29, 55, 78);
  width: auto;
}
.subdirectory span {
  margin-right: 15px;
  color: #bec5ca;
}
.subdirectory-right span {
  margin-right: 15px;
  color: #bec5ca;
}
::-webkit-scrollbar {
  width: 3px; /* 纵向滚动条 宽度 */
  height: 0; /* 横向滚动条 高度 */
  background: #163d5e; /* 整体背景 */
}
::-webkit-scrollbar-thumb {
  background: #bec5ca;
  min-height: 10px;
  min-width: 10px;
  border-radius: 10px;
}
/deep/.el-timeline-item__tail {
  position: absolute;
  left: 22px;
  height: 100%;
  border-left: 2px solid #e4e7ed;
  top: 35px;
  z-index: 9;
}
/deep/.el-timeline-item__node--normal {
  border: 2px solid rgb(230, 233, 234);
  left: 15px;
  width: 12px;
  height: 12px;
  top: 25px;
  background-color: rgb(1, 32, 59);
  z-index: 10;
}
#players {
  width: 100%;
  height: 500px;
  background-color: rgb(2, 32, 58);
}
</style>
